(ns motorsaif.web.storage
  (:refer-clojure :exclude [get])
  (:require
   [motorsaif.log :as log]
   [clojure.edn :as edn]))

(defn write [key data]
  (.setItem js/localStorage (name key) (pr-str data)))

(defn clear [key]
  (.removeItem js/localStorage (name key)))

(defn get [key]
  (try
    (edn/read-string (.getItem js/localStorage (name key)))
    (catch js/Error e
      (log/info [:edn-read-error e]))))
